module.exports = __webpack_public_path__ + "img/seaPalace-4.b42ff2a6.jpg";